var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":'Recent Publications'}}),_c('Layout',{attrs:{"preKey":_vm._category,"columnComponents":_vm.Cards,"language":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }